import React from 'react'
import { Link } from 'react-router-dom'

export function Footer() {
  const links = [
    { to: '/', label: 'Home' },
    { to: '/pricing', label: 'Pricing' },
    { to: '/docs', label: 'Docs' },

    { to: '/tutorial', label: 'Tutorial' },
    { to: '/blog', label: 'Blog' },
    { to: '/supported-nodes', label: 'Supported Nodes' },
    { to: '/contact', label: 'Contact' },
    { to: '/terms', label: 'Terms' },
    { to: '/privacy', label: 'Privacy' }
  ]

  return (
    <footer className="border-t py-6 text-sm">
      <div className="container mx-auto px-4 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <nav className="flex flex-wrap gap-x-4 gap-y-2 text-muted-foreground">
          {links.map((l) => (
            <Link key={l.to} to={l.to} className="hover:text-foreground transition-colors">
              {l.label}
            </Link>
          ))}
          <a href="mailto:contact@n8n2py.me" className="hover:text-foreground transition-colors">
            Email Us
          </a>
          <a href="https://www.producthunt.com/posts/n8n2py-me-convert-n8n-flows-to-python?utm_source=other&utm_medium=social" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">
            Product Hunt
          </a>
        </nav>
        <div className="flex items-center gap-4 text-muted-foreground">
          <button
            className="underline"
            onClick={() => window.dispatchEvent(new Event('open-analytics-consent'))}
          >
            Analytics Settings
          </button>
          <span className="text-xs">© {new Date().getFullYear()} n8n2py</span>
        </div>
      </div>
    </footer>
  )
}
